import { render, staticRenderFns } from "./QrRegistrationButton.vue?vue&type=template&id=65681b4a"
import script from "./QrRegistrationButton.vue?vue&type=script&lang=ts"
export * from "./QrRegistrationButton.vue?vue&type=script&lang=ts"
import style0 from "./QrRegistrationButton.vue?vue&type=style&index=0&id=65681b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports